import Button from "@mui/material/Button";

export const MineBtn = ({
  text,
  link,
  sx,
}: {
  text: any;
  link?: any;
  sx?: any;
}) => {
  console.log(sx);
  return (
    <Button
    href={link || ''}
    className="mine-btn"
      sx={{
        ...sx,
        color: "var(--c-text-color)",
        fontWeight: 700,
        borderRadius: "24px",
        backgroundColor: "var(--c-bg-content-color)",
        border: "2px solid var(--c-bg-content-color)",
        boxShadow: "var(--c-box-shadow-btn)",
        "&:hover": {
          backgroundColor: "var(--c-main-color)",
          boxShadow: "var(--c-box-shadow-btn)",
        },
      }}
      variant="contained"
    >
      {text}
    </Button>
  );
};
